import React, {useState} from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Form,
    Input,
    Label,
    FormFeedback,
    Spinner,
} from 'reactstrap';
import logoLight from "../../assets/images/logo-light.png";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ParticlesAuth from "./ParticlesAuth";
import withRouter from "../.././components/withRouter";
import { postResetPwd } from '../../api/authApi';
import { toast } from 'react-toastify';

const ResetPassw = (props: any) => {
    const navigate = useNavigate();
    const [loader, setLoader] = useState<boolean>(false);
    const [searchParams] = useSearchParams();
    const [passwordShow, setPasswordShow] = useState<boolean>(false);
    const [confirmPasswordShow, setConfirmPasswordShow] = useState<boolean>(false);

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            password: "",
            confirm_password: "",
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .min(8, 'A senha deve ter pelo menos 8 caracteres')
                .matches(RegExp('(.*[a-z].*)'), 'Pelo menos letra minúscula')
                .matches(RegExp('(.*[A-Z].*)'), 'Pelo menos letra maiúscula')
                .matches(RegExp('(.*[0-9].*)'), 'Pelo menos um número')
                .required("Este campo é obrigatório"),
            confirm_password: Yup.string()
                .oneOf([Yup.ref('password'), ""],)
                .required('Confirmar senha é obrigatório')
        }),
        onSubmit: (values) => {
            setLoader(true);
            const token = searchParams.get('token');
            if (token) {
                postResetPwd(token, values.password)
                    .then(() => {
                        validation.resetForm();
                        validation.setSubmitting(false);
                        validation.setStatus({ success: true });
                        toast.success('Senha redefinida com sucesso!');
                        navigate('/login');
                    })
                    .catch(() => {})
                    .finally(() => {
                        setLoader(false);
                    });
            } else {
                toast.error('Token inválido');
                setLoader(false);
            }
        },
    });
    document.title = "Criar nova senha | Ad Pulse";
    return (
        <ParticlesAuth>
            <div className="auth-page-content mt-lg-5">
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className="text-center mt-sm-5 mb-4 text-white-50">
                                <div>
                                    <Link to="/#" className="d-inline-block auth-logo">
                                        <img src={logoLight} alt="" height="60" />
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="mt-4">

                                <CardBody className="p-4">
                                    <div className="text-center mt-2">
                                        <h5 className="text-primary">Criar nova senha</h5>
                                        <p className="text-muted">Sua nova senha deve ser diferente da senha usada anteriormente.</p>
                                    </div>
                                    <div className="p-2">
                                        <Form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                            action="#">
                                            <div className="mb-3">
                                                <Label className="form-label" htmlFor="password-input">Senha</Label>
                                                <div className="position-relative auth-pass-inputgroup">
                                                    <Input
                                                        type={passwordShow ? "text" : "password"}
                                                        className="form-control pe-5 password-input"
                                                        placeholder="Digite a senha"
                                                        id="password-input"
                                                        name="password"
                                                        value={validation.values.password}
                                                        onBlur={validation.handleBlur}
                                                        onChange={validation.handleChange}
                                                        invalid={!!(validation.errors.password && validation.touched.password)}
                                                    />
                                                    {validation.errors.password && validation.touched.password ? (
                                                        <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                    ) : null}
                                                    <Button color="link" onClick={() => setPasswordShow(!passwordShow)} className="position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button"
                                                            id="password-addon"><i className="ri-eye-fill align-middle"></i></Button>
                                                </div>
                                                <div id="passwordInput" className="form-text">Deve ter pelo menos 8 caracteres.</div>
                                            </div>

                                            <div className="mb-3">
                                                <Label className="form-label" htmlFor="confirm-password-input">Confirme sua senha</Label>
                                                <div className="position-relative auth-pass-inputgroup mb-3">
                                                    <Input
                                                        type={confirmPasswordShow ? "text" : "password"}
                                                        className="form-control pe-5 password-input"
                                                        placeholder="Confirm password"
                                                        id="confirm-password-input"
                                                        name="confirm_password"
                                                        value={validation.values.confirm_password}
                                                        onBlur={validation.handleBlur}
                                                        onChange={validation.handleChange}
                                                        invalid={!!(validation.errors.confirm_password && validation.touched.confirm_password)}
                                                    />
                                                    {validation.errors.confirm_password && validation.touched.confirm_password ? (
                                                        <FormFeedback type="invalid">{validation.errors.confirm_password}</FormFeedback>
                                                    ) : null}
                                                    <Button color="link" onClick={() => setConfirmPasswordShow(!confirmPasswordShow)} className="position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button">
                                                        <i className="ri-eye-fill align-middle"></i></Button>
                                                </div>
                                            </div>

                                            <div id="password-contain" className="p-3 bg-light mb-2 rounded">
                                                <h5 className="fs-13">A senha deve conter:</h5>
                                                <p id="pass-length" className="invalid fs-12 mb-2">Mínimo de <b>8 caracteres</b></p>
                                                <p id="pass-lower" className="invalid fs-12 mb-2">Uma letra <b>minúscula</b> (a-z)</p>
                                                <p id="pass-upper" className="invalid fs-12 mb-2">Uma letra <b>maiúscula</b> (A-Z)</p>
                                                <p id="pass-number" className="invalid fs-12 mb-0">Um <b>número</b> (0-9)</p>
                                            </div>

                                            <div className="mt-4">
                                                <Button color="success"
                                                        disabled={loader && true}
                                                        className="btn btn-success w-100" type="submit">
                                                    {loader && <Spinner size="sm" className='me-2'> Carregando... </Spinner>}
                                                    Redefinir senha
                                                </Button>
                                            </div>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>
                            <div className="mt-4 text-center">
                                <p className="mb-0">Espere, eu lembro da minha senha... <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> Clique aqui </Link> </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </ParticlesAuth>
    );
};

export default withRouter(ResetPassw);